import type { RouteComponentProps } from '@reach/router';
import React from 'react';
import { withErrorBoundary } from 'react-error-boundary';
import { defineMessages, useIntl } from 'react-intl';

import { ErrorBoundaryFallback } from '@components/ErrorBoundaryFallback';

import { useGetLatestObservations } from '@hooks/api/observation';

import { TrackerType } from '@models/vital-sign';

import HealthTrackerMain from '@views/Records/HealthTracker/Main';

const messages = defineMessages({
  title: {
    id: 'sleepMain.title',
    defaultMessage: 'Sleep',
  },
});

const SleepMain: React.FC<RouteComponentProps> = () => {
  const { formatMessage } = useIntl();

  const {
    data: { sleep_average_heart_rate, sleep_duration, sleep_score },
    loading,
  } = useGetLatestObservations({
    sleep_duration: true,
    sleep_score: true,
    sleep_average_heart_rate: true,
  });

  const records = {
    sleep_duration,
    sleep_score,
    average_heart_rate: sleep_average_heart_rate,
  };

  return (
    <HealthTrackerMain
      category={TrackerType.Sleep}
      loading={loading}
      records={records}
      title={formatMessage(messages.title)}
    />
  );
};

export default withErrorBoundary(SleepMain, {
  FallbackComponent: ErrorBoundaryFallback,
});
